import { useEffect, useState } from "react";
import { OBMarketingAnswerModel } from "@models/Models";
import ParticlesBackground from "@components/common/ParticlesBackground";
import { MxResult, OBPersonaAnswerKey } from "@models/Enums";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { kAnalyticsConstants } from "@utils/constants/AnalyticsConstants";
import { recordEvent } from "@utils/managers/AnalyticsManager";
import MarketingRow from "../Marketing/MarketingRow";
import { postOnboardingMarketingAnswer, postOnboardingPersonaAnswers } from "@utils/managers/networking/NetworkManager";
import OnboardingGoalModal from "@components/common/OnboardingGoalModal";
import { useOnboardingProfile } from "@providers/OnboardingContext";

const PriorityPersona = (props) => {

    const getArray = (selectedAnswerList: string[], answers: OBMarketingAnswerModel[]): OBMarketingAnswerModel[] => {
        const selectedPersonaAnswers = answers.filter((x) => selectedAnswerList.includes(x.key));
		return selectedPersonaAnswers;
	};
	

	const [selectedAnswer, setSelectedAnswer] = useState<string | undefined>(undefined);
	const [isModalShow, setIsModalShow] = useState<boolean>(false);
    const { onboardingProfile, setOnboardingProfile } = useOnboardingProfile();
	const [marketingAnswers] = useState(() => getArray(onboardingProfile!.persistence.personaAnswers, onboardingProfile!.persistence.answersList));
	const navigate = useNavigate();

	useEffect(() => {
		recordEvent(kAnalyticsConstants.Onboarding.priorirtyAnswerAnswered);
	}, []);

	const onAnswerClick = (answer: OBMarketingAnswerModel) => {
		if (selectedAnswer == answer.key) {
			setSelectedAnswer(selectedAnswer);
		} else {
			setSelectedAnswer(answer.key);
		}
	};

	const goToNextScreen = () => {
		if (selectedAnswer === undefined) {
			return;
		}

		var tempOnboardingProfile = { ...onboardingProfile! };
		tempOnboardingProfile.persistence.priorityAnswer = selectedAnswer;
		setOnboardingProfile(tempOnboardingProfile);
		recordEvent(kAnalyticsConstants.Onboarding.priorirtyAnswerAnswered, { question_key: "segment_question", selected_answers: marketingAnswers.map((x) => x.key), priority_answer: selectedAnswer });
		postOnboardingPersonaAnswers("segment_question", marketingAnswers.map((x) => x.key), selectedAnswer);
		setIsModalShow(true);
	};

	return (
		<div>
			<ParticlesBackground />
			<OnboardingGoalModal isShow={isModalShow} setIsShow={() => setIsModalShow(false)} selectedAnswer={selectedAnswer} />
			<div className={`flex min-h-[100dvh] flex-col md:justify-center justify-start py-2 pointer-events-auto`}>
				<div className="fixed top-0 bg-black/50 w-full p-3 z-30 backdrop-blur-lg border-b border-white/10 shadow-2xl">
					<div className="max-w-[1080px] w-full z-30 m-auto">
						<div className="flex justify-end items-center">
							<button className={`text-white font-medium font-primary text-lg focus:outline-none rounded-xl p-2 px-3 py-2 items-center bg-success-green/80 hover:bg-success-green/100 transition ease-in-out whitespace-nowrap ${selectedAnswer === undefined ? "opacity-50 cursor-not-allowed" : ""}`} onClick={goToNextScreen} disabled={selectedAnswer === undefined}>Next</button>
						</div>
					</div>
				</div>
				<div className="flex flex-col gap-10 items-center justify-center p-3 mt-[50px] md:mt-[80px]">
					<div className="meco_container max-w-[1080px] py-[40px] md:p-[60px] md:pb-[40px]">
						<div className="flex flex-col md:flex-row gap-5 w-full justify-between">
							<div className="sticky md:top-[90px] w-full md:w-1/2 flex flex-col gap-2">
                                <div className="text-white font-bold font-primary text-4xl leading-10">Got it! And if you had to pick one?</div>
                                <div className="text-force-primary-light font-medium font-primary text-base  md:text-xl">Choose the one that's most important to you</div>
							</div>
							<div className="w-full md:w-1/2 flex flex-col items-center justify-center gap-3 max-w-[450px] md:max-w-none m-auto md:min-w-[400px]">
								<div className="text-white font-medium font-primary text-3xl text-center w-full max-w-[600px] mb-5  no-select">
									{marketingAnswers.map((answer, i) => {
										return <MarketingRow marketingAnswer={answer} isSelected={selectedAnswer === answer.key} onSelect={onAnswerClick} />;
									})}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PriorityPersona;
